<script>
import Ckeditor from "./ckeditor.vue";

export default {
    extends: Ckeditor
};
</script>